module.exports = __webpack_public_path__ + "img/i6.5dd9b3b2.svg";